import { EffectCallback, useEffect } from 'react'

export const useOnMount = (onMountFn: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => onMountFn(), [])
}
